<auth-layout title="Upload Documentation" type="SIGNUP" subTitile="" [isHiddenImage]="true" [hideHeader]="true">
    <div class="login-page">
        <div class="login-card">
            <div class="login-header">
                <h2>Upload Documents</h2>
                <p class="subtitle">Upload the required documents to complete your profile.</p>
            </div>

            <form class="login-form">
                <div class="form-group">
                    <p class="owner">Business Documents</p>

                    <div class="d-flex justify-content-between">
                        <div class="w-100">
                            <label class="for-label">Certificate Of Incorporation ( Business Registration Letter )</label>
                            <div class="for-validation text-danger" *ngIf="!IncorporationForntUrl"><span class="yy">*</span>(Only PDF or DOCX files are allowed).</div>
                            <div class="form-group">
                                <input id="file-upload1" #fileInput1 type="file" accept=".pdf,.docx"
                                    class="form-control custom-file-input"
                                    (change)="uploadImg($event,'INCORPORATIONFORNT',1)">
                            </div>
                        </div>
                    </div>

                    <div class="d-flex justify-content-between">
                        <div class="w-100">
                            <label class="for-label">VAT Registration Confirmation ( If Applicable )</label>
                            <div class="for-validation text-danger" *ngIf="!VatForntUrl"><span class="yy">*</span>(Only PDF or DOCX files are allowed).</div>
                            <div class="form-group">
                                <input id="file-upload2" #fileInput2 type="file" accept=".pdf,.docx"
                                    class="form-control custom-file-input"
                                    (change)="uploadImg($event,'VATFORNT',2)">
                            </div>
                        </div>
                    </div>

                    <div class="d-flex justify-content-between">
                        <div class="w-100">
                            <label class="for-label">Director Consent Form ( To Be Completed )</label>
                            <div class="for-validation text-danger" *ngIf="!DirectorForntUrl"><span class="yy">*</span>(Only PDF or DOCX files are allowed).</div>
                            <div class="form-group">
                                <input id="file-upload3" #fileInput3 type="file" accept=".pdf,.docx"
                                    class="form-control custom-file-input"
                                    (change)="uploadImg($event,'DIRECTORFORNT',3)">
                            </div>
                        </div>
                    </div>

                    <div class="d-flex justify-content-between">
                        <div class="w-100">
                            <label class="for-label">Director (s) ID Document</label>
                            <div class="for-validation text-danger" *ngIf="!DirectorIDDocumentUrl"><span class="yy">*</span>(Only PDF or DOCX files are allowed).</div>
                            <div class="form-group">
                                <input id="file-upload4" #fileInput4 type="file" accept=".pdf,.docx"
                                    class="form-control custom-file-input"
                                    (change)="uploadImg($event,'DIRECTORDOCUMENT',4)">
                            </div>
                        </div>
                    </div>

                    <div class="d-flex justify-content-between">
                        <div class="w-100">
                            <label class="for-label">Bank Confirmation Letter</label>
                            <div class="for-validation text-danger" *ngIf="!ConfirmationForntUrl"><span class="yy">*</span>(Only PDF or DOCX files are allowed).</div>
                            <div class="form-group">
                                <input id="file-upload5" #fileInput5 type="file" accept=".pdf,.docx"
                                    class="form-control custom-file-input"
                                    (change)="uploadImg($event,'CONFIRMATIONFORNT',5)">
                            </div>
                        </div>
                    </div>
                </div>

                <div class="form-group submit-div">
                    <div class="d-flex justify-content-center">
                        <button class="btn btny for-login"
                            [disabled]="isSubmitDisabled()"
                            *ngIf="!loading"
                            (click)="imgeUplode()" type="submit">
                            {{ submitButtonText }}
                        </button>
                        <button class="btn btny for-login op05"
                            *ngIf="loading && uploadedDocument != totalDocument"
                            type="submit">
                            Document uploaded {{uploadedDocument}}/{{totalDocument}}
                        </button>
                        <button class="btn btny for-login op05"
                            *ngIf="loading && uploadedDocument == totalDocument"
                            type="submit">
                            Loading...
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</auth-layout>